<template>
  <div id="mobileMenu" class="mobileMenu">
    <div class="mobileMain">
      <!-- <img src="../../components/image/menu-line.png"  /> -->
      <p id="menuBtn" class="menuBtn">&#9776;</p>
      <router-link :to="{ name: '홈' }">
        <!-- <img id="mainImg" class="mainImg" src="@/components/image/jungnanglogo.png"/> -->
        <img id="mainImg" class="mainImg" src="@/components/image/gangmenglogo.png" />
      </router-link>
    </div>

    <!-- dropDown mobileMenu -->

    <div id="mobileDropDown" class="mobileDropDown">
      <ul class="logoTitle">
        <div class="mainFullTitle">
          <div class="mainTitle closeWrapper">
            <div class="mobile-close-button" id="closeBtn">닫기</div>
            <!-- <img class="titleImg" src="@/components/image/jungnanglogo_menu.png"/> -->
            <img class="titleImg" src="@/components/image/gangmenglogo_white.png" />

            <!-- <el-button id="closeBtn" class="closeBtn">닫기</el-button> -->
          </div>
        </div>

        <div class="loginMobile">
          <div class="memberButton" v-if="this.$store.state.isLogin == false">
            <router-link :to="{ name: '로그인' }">
              <el-button type="text" id="loginBtn" class="loginBtn"> 로그인 </el-button>
            </router-link>

            <a class="bar"> | </a>

            <router-link :to="{ name: '회원선택' }">
              <el-button type="text" id="memberBtn" class="memberBtn">
                회원가입
              </el-button>
            </router-link>
          </div>

          <div class="memberButton" v-if="this.$store.state.isLogin == true">
            <router-link :to="{ name: '차량 등록 관리', query: { select: 'total' } }">
              <el-button type="text" id="myPageBtn" class="loginBtn">
                마이페이지
              </el-button>
            </router-link>

            <a class="myBar"> | </a>

            <el-button type="text" id="logoutBtn" class="memberBtn"> 로그아웃 </el-button>
          </div>
        </div>
      </ul>

      <!-- first menu -->
      <ul class="FirstMenu">
        <div id="firstTitle" class="title">
          <span class="clickTitleFirst">{{ MenuInfo[0].title }}</span>
          <span class="mobileFirstArrow">&rsaquo;</span>
        </div>

        <hr class="line1" />

        <div id="firstSubMenu" class="firstSubMenu">
          <router-link
            :to="{ name: '주차장 소개' }"
            class="subMenuRouterLink"
            style="text-decoration: none; color: #707070"
          >
            <p class="marker">&#9632;</p>
            <li id="parkInfoLink" class="subMenu">{{ MenuInfo[0].submenu1 }}</li>
          </router-link>

          <hr class="line2" />

          <!-- <router-link :to="{ name: '담당부서 안내' }" style="text-decoration:none; color:#707070">
                        <p class="marker">&#9632;</p>
                        <li id="guidance" class="subMenu">{{MenuInfo[0].submenu2}}</li>
                    </router-link> -->

          <!-- <hr class="line2" /> -->
        </div>
      </ul>

      <!-- second menu -->
      <ul class="secondMenu">
        <div id="secondTitle" class="title">
          <span id="clickTitleSecond" class="clickTitleSecond">
            {{ MenuInfo[1].title }}
          </span>
          <span class="mobileArrow">&rsaquo;</span>
        </div>

        <hr class="line1" />

        <div id="secondSubMenu" class="secondSubMenu">
          <!-- <router-link :to="{ name: '요금안내' }" style="text-decoration:none; color:#707070">
                        <p class="marker">&#9632;</p>
                        <li id="secondSubFirst" class="subMenu">
                            {{MenuInfo[1].submenu1}}
                        </li>
                    </router-link> -->
          <ul class="dropMenu">
            <p class="marker">&#9632;</p>
            <li id="subMenuDrop" class="subMenu">
              {{ MenuInfo[1].submenu1 }}
            </li>

            <hr class="line4" />

            <div id="secondDropMenu" class="secondDropMenu">
              <router-link
                id="coinInfo"
                :to="{ name: '요금안내' }"
                style="text-decoration: none; color: #707070"
              >
                <p class="subMarker">&#9632;</p>
                <li class="dropSubMenu">
                  {{ MenuInfo[1].submenu11 }}
                </li>
              </router-link>

              <hr class="line3" />

              <router-link
                id="discountInfo"
                :to="{ name: '할인안내' }"
                style="text-decoration: none; color: #707070"
              >
                <p class="subMarker">&#9632;</p>
                <li class="dropSubMenu">
                  {{ MenuInfo[1].submenu6 }}
                </li>
              </router-link>

              <!-- <hr class="line3" /> -->

              <!-- <router-link id="schoolParkInfo" :to="{ name: '학교주차장 현황' }" style="text-decoration:none; color:#707070">
                                <p class="subMarker">&#9632;</p>
                                <li class="dropSubMenu">
                                    {{MenuInfo[1].submenu23}}
                                </li>
                            </router-link> -->

              <!-- <hr class="line3" /> -->
            </div>
          </ul>

          <hr class="line2" />

          <ul class="dropMenu">
            <p class="marker">&#9632;</p>
            <li id="subMenuDrop" class="subMenu">
              {{ MenuInfo[1].submenu2 }}
            </li>

            <hr class="line4" />

            <div id="secondDropMenu" class="secondDropMenu">
              <router-link
                id="upParkInfo"
                :to="{ name: '노상주차장 현황' }"
                style="text-decoration: none; color: #707070"
              >
                <p class="subMarker">&#9632;</p>
                <li class="dropSubMenu">
                  {{ MenuInfo[1].submenu21 }}
                </li>
              </router-link>

              <hr class="line3" />

              <router-link
                id="outParkInfo"
                :to="{ name: '노외주차장 현황' }"
                style="text-decoration: none; color: #707070"
              >
                <p class="subMarker">&#9632;</p>
                <li class="dropSubMenu">
                  {{ MenuInfo[1].submenu22 }}
                </li>
              </router-link>

              <hr class="line3" />

              <!-- <router-link id="schoolParkInfo" :to="{ name: '학교주차장 현황' }" style="text-decoration:none; color:#707070">
                                <p class="subMarker">&#9632;</p>
                                <li class="dropSubMenu">
                                    {{MenuInfo[1].submenu23}}
                                </li>
                            </router-link> -->

              <!-- <hr class="line3" /> -->
            </div>
          </ul>

          <router-link
            :to="{ name: '안내사항' }"
            style="text-decoration: none; color: #707070"
          >
            <p class="checkMarker">&#9632;</p>
            <li id="parkingInformation" class="checkSubMenuInfo">
              {{ MenuInfo[1].submenu5 }}
            </li>
          </router-link>

          <hr class="line2" />

          <router-link
            :to="{ name: '확인' }"
            style="text-decoration: none; color: #707070"
          >
            <p class="checkMarker">&#9632;</p>
            <li id="secondSubThird" class="checkSubMenu">
              {{ MenuInfo[1].submenu3 }}
            </li>
          </router-link>

          <hr class="line2" />
        </div>
      </ul>

      <!-- third menu -->
      <!-- <ul class="thirdMenu">

                <div id="thirdTitle" class="title">
                    <span id="clickTitleThird" class="clickTitleThird">
                        {{MenuInfo[2].title}}
                    </span>
                    <span class="mobileArrow">&rsaquo;</span>
                </div>

                <hr class="line1" /> -->

      <!-- <div id="thirdSubMenu" class="thirdSubMenu">
                    
                    <router-link :to="{ name: '실시간정보' }" style="text-decoration:none; color:#707070">
                        <p class="marker">&#9632;</p>
                        <li id="timeStampLink" class="subMenu">
                            {{MenuInfo[2].submenu1}}
                        </li>
                    </router-link>

                    <hr class="line2" /> -->

      <!-- <li class="subMenu">{{MenuInfo[2].submenu2}}</li> -->
      <!-- </div> -->

      <!-- </ul> -->

      <!-- fourth menu -->
      <ul class="fourMenu">
        <div id="forthTitle" class="title">
          <span id="clickTitleForth" class="clickTitleForth">
            {{ MenuInfo[3].title }}
          </span>
          <span class="mobileArrow">&rsaquo;</span>
        </div>

        <hr class="line1" />

        <div id="fourSubMenu" class="fourSubMenu">
          <router-link
            :to="{ name: '공지 사항' }"
            style="text-decoration: none; color: #707070"
          >
            <p class="marker">&#9632;</p>
            <li id="notice" class="subMenu">
              {{ MenuInfo[3].submenu1 }}
            </li>
          </router-link>

          <hr class="line2" />

          <router-link
            :to="{ name: '자주하는 질문' }"
            style="text-decoration: none; color: #707070"
          >
            <p class="marker">&#9632;</p>
            <li id="frequently" class="subMenu">
              {{ MenuInfo[3].submenu2 }}
            </li>
          </router-link>

          <hr class="line2" />

          <router-link
            :to="{ name: '차량변경/환불요청' }"
            style="text-decoration: none; color: #707070"
          >
            <p class="marker">&#9632;</p>
            <li id="questions" class="subMenu">
              {{ MenuInfo[3].submenu3 }}
            </li>
          </router-link>

          <!-- safari error -->
          <hr class="line2" />
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import Menu from "@/assets/index/menu";
import build from "@/api/example";

export default {
  data() {
    return {
      activeIndex: this.$route.path,
      MenuInfo: Menu,
      width: 200,
      startEvent: false,
      moveEvent: false,
      mobileTouch: true,
      checkMobile: false,
      adminPageUrl: process.env.VUE_APP_ADMINPAGE_URL,
      userName: "",

      openCheckMenu: false,
    };
  },
  methods: {
    checkLogin() {
      build
        .get("/mer/api/member")
        .then((res) => {
          //인증된 사용자가 정보가 서버에 있을 경우
          this.$store.state.isLogin = true;

          if (res.data.userSe === "ADMIN") {
            this.$store.state.isAdmin = true;
          }

          if (res.data.userSe === "BSN") {
            this.$store.state.isBusiness = true;
          }
        })
        .catch((err) => {
          //인증된 사용자가 정보가 서버에 없을 경우
          this.$store.state.isLogin = false;
          this.$store.state.isAdmin = false;
          this.$store.state.isBusiness = false;
          console.log(err);
        });
    },
    openDropDown() {
      const subMenuFirst = document.getElementById("firstTitle");
      const subMenuSecond = document.getElementById("secondTitle");
      // const subMenuThird = document.getElementById("thirdTitle");
      const subMenuForth = document.getElementById("forthTitle");

      const showMenuFirst = document.getElementById("firstSubMenu");
      const showMenuSecond = document.getElementById("secondSubMenu");
      // const showMenuThird = document.getElementById("thirdSubMenu");
      const showMenuForth = document.getElementById("fourSubMenu");

      // const secondSubFirst = document.getElementById("secondSubFirst");
      // const secondSubThird = document.getElementById("secondSubThird");
      // const secondDrop = document.getElementById("subMenuDrop");
      // const dropDown = document.getElementById("secondDropMenu");

      document.addEventListener(
        "touchstart",
        (e) => {
          e.preventDefault();

          // e.stopPropagation();

          this.startEvent = true;
        },
        { passive: false }
      );

      document.addEventListener(
        "touchmove",
        (e) => {
          e.preventDefault();
          // e.stopPropagation()

          if (!this.startEvent) {
            return;
          }
          this.moveEvent = true;
        },
        { passive: false }
      );

      /* firstMenu */
      subMenuFirst.addEventListener("click", () => {
        if (showMenuFirst.style.display == "none") {
          showMenuFirst.style.display = "block";

          //reset
          showMenuSecond.style.display = "none";
          // showMenuThird.style.display = 'none';
          // showMenuForth.style.display = 'none';
          showMenuForth.style.visibility = "hidden";

          // dropDown.style.display = 'none';
        } else if (showMenuFirst.style.display == "block") {
          showMenuFirst.style.display = "none";

          //reset
          showMenuSecond.style.display = "none";
          // showMenuThird.style.display = 'none';
          // showMenuForth.style.display = 'none';
          showMenuForth.style.visibility = "hidden";

          // dropDown.style.display = 'none';
        } else {
          showMenuFirst.style.display = "block";

          //reset
          showMenuSecond.style.display = "none";
          // showMenuThird.style.display = 'none';
          // showMenuForth.style.display = 'none';
          showMenuForth.style.visibility = "hidden";

          // dropDown.style.display = 'none';
        }
      });

      subMenuFirst.addEventListener(
        "touchend",
        (ev) => {
          ev.preventDefault();

          if (showMenuFirst.style.display == "none") {
            showMenuFirst.style.display = "block";

            //reset
            showMenuSecond.style.display = "none";
            // showMenuThird.style.display = 'none';
            // showMenuForth.style.display = 'none';
            showMenuForth.style.visibility = "hidden";

            // dropDown.style.display = 'none';
          } else if (showMenuFirst.style.display == "block") {
            showMenuFirst.style.display = "none";

            //reset
            showMenuSecond.style.display = "none";
            // showMenuThird.style.display = 'none';
            // showMenuForth.style.display = 'none';
            showMenuForth.style.visibility = "hidden";

            // dropDown.style.display = 'none';
          } else {
            showMenuFirst.style.display = "block";

            //reset
            showMenuSecond.style.display = "none";
            // showMenuThird.style.display = 'none';
            // showMenuForth.style.display = 'none';
            showMenuForth.style.visibility = "hidden";

            // dropDown.style.display = 'none';
          }
        },
        { passive: false }
      );

      /* secondMenu */
      subMenuSecond.addEventListener("click", () => {
        if (showMenuSecond.style.display == "none") {
          showMenuSecond.style.display = "block";

          //reset
          showMenuFirst.style.display = "none";
          // showMenuThird.style.display = 'none';
          // showMenuForth.style.display = 'none';
          showMenuForth.style.visibility = "hidden";

          // dropDown.style.display = 'none';
        } else if (showMenuSecond.style.display == "block") {
          showMenuSecond.style.display = "none";

          //reset
          showMenuFirst.style.display = "none";
          // showMenuThird.style.display = 'none';
          // showMenuForth.style.display = 'none';
          showMenuForth.style.visibility = "hidden";

          // dropDown.style.display = 'none';
        } else {
          showMenuSecond.style.display = "block";

          //reset
          showMenuFirst.style.display = "none";
          // showMenuThird.style.display = 'none';
          // showMenuForth.style.display = 'none';
          showMenuForth.style.visibility = "hidden";

          // dropDown.style.display = 'none';
        }
      });

      subMenuSecond.addEventListener(
        "touchend",
        (ev) => {
          ev.preventDefault();

          if (showMenuSecond.style.display == "none") {
            showMenuSecond.style.display = "block";

            //reset
            showMenuFirst.style.display = "none";
            // showMenuThird.style.display = 'none';
            // showMenuForth.style.display = 'none';
            showMenuForth.style.visibility = "hidden";

            // dropDown.style.display = 'none';
          } else if (showMenuSecond.style.display == "block") {
            showMenuSecond.style.display = "none";

            //reset
            showMenuFirst.style.display = "none";
            // showMenuThird.style.display = 'none';
            // showMenuForth.style.display = 'none';
            showMenuForth.style.visibility = "hidden";

            // dropDown.style.display = 'none';
          } else {
            showMenuSecond.style.display = "block";

            //reset
            showMenuFirst.style.display = "none";
            // showMenuThird.style.display = 'none';
            // showMenuForth.style.display = 'none';
            showMenuForth.style.visibility = "hidden";

            // dropDown.style.display = 'none';
          }
        },
        { passive: false }
      );

      /* subMenu dropDown 실행 불가 시작 */

      /* secondSubFirst */
      // secondSubFirst.addEventListener('click', () => {
      //     if(dropDown.style.display == 'none') {
      //         dropDown.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';

      //     } else if(dropDown.style.display == 'block') {
      //         dropDown.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';
      //     } else {
      //         dropDown.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';
      //     }
      // });

      // secondSubFirst.addEventListener('touchend', (ev) => {
      //     ev.preventDefault();

      //     if(dropDown.style.display == 'none') {
      //         dropDown.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';

      //     } else if(dropDown.style.display == 'block') {
      //         dropDown.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';
      //     } else {
      //         dropDown.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';
      //     }
      // },{passive: false});

      // /* secondSubThird */
      // secondSubThird.addEventListener('click', () => {
      //     if(dropDown.style.display == 'none') {
      //         dropDown.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';

      //     } else if(dropDown.style.display == 'block') {
      //         dropDown.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';
      //     } else {
      //         dropDown.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';
      //     }
      // });

      // secondSubThird.addEventListener('touchend', (ev) => {
      //     ev.preventDefault();

      //     if(dropDown.style.display == 'none') {
      //         dropDown.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';

      //     } else if(dropDown.style.display == 'block') {
      //         dropDown.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';
      //     } else {
      //         dropDown.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';
      //     }

      // },{passive: false});

      // /* subMenu dropDown 실행 불가 끝 */

      // /* secondDropMenu */
      // secondDrop.addEventListener('click', () => {
      //     if(dropDown.style.display == 'none') {
      //         dropDown.style.display = 'block';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';

      //     } else if(dropDown.style.display == 'block') {
      //         dropDown.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';
      //     } else {
      //         dropDown.style.display = 'block';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';
      //     }
      // });

      // secondDrop.addEventListener('touchend', (ev) => {
      //     ev.preventDefault();

      //     if(dropDown.style.display == 'none') {
      //         dropDown.style.display = 'block';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';

      //     } else if(dropDown.style.display == 'block') {
      //         dropDown.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';
      //     } else {
      //         dropDown.style.display = 'block';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuThird.style.display = 'none';
      //         showMenuForth.style.display = 'none';
      //     }

      // },{passive: false});

      /* thirdMenu */
      // subMenuThird.addEventListener('click', () => {
      //     if(showMenuThird.style.display == 'none') {
      //         showMenuThird.style.display = 'block';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuSecond.style.display = 'none';
      //         showMenuForth.style.display = 'none';

      //         // dropDown.style.display = 'none';

      //     } else if(showMenuThird.style.display == 'block') {
      //         showMenuThird.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuSecond.style.display = 'none';
      //         showMenuForth.style.display = 'none';

      //         // dropDown.style.display = 'none';
      //     } else {
      //         showMenuThird.style.display = 'block';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuSecond.style.display = 'none';
      //         showMenuForth.style.display = 'none';

      //         // dropDown.style.display = 'none';
      //     }
      // });

      // subMenuThird.addEventListener('touchend', (ev) => {
      //     ev.preventDefault();

      //     if(showMenuThird.style.display == 'none') {
      //         showMenuThird.style.display = 'block';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuSecond.style.display = 'none';
      //         showMenuForth.style.display = 'none';

      //         // dropDown.style.display = 'none';

      //     } else if(showMenuThird.style.display == 'block') {
      //         showMenuThird.style.display = 'none';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuSecond.style.display = 'none';
      //         showMenuForth.style.display = 'none';

      //         // dropDown.style.display = 'none';
      //     } else {
      //         showMenuThird.style.display = 'block';

      //         //reset
      //         showMenuFirst.style.display = 'none';
      //         showMenuSecond.style.display = 'none';
      //         showMenuForth.style.display = 'none';

      //         // dropDown.style.display = 'none';
      //     }

      // },{passive: false});

      /* forthMenu */
      subMenuForth.addEventListener("click", () => {
        if (showMenuForth.style.visible == "hidden") {
          // showMenuForth.style.display = 'block';
          showMenuForth.style.visibility = "visible";

          //reset
          showMenuFirst.style.display = "none";
          showMenuSecond.style.display = "none";
          // showMenuThird.style.display = 'none';

          // dropDown.style.display = 'none';
        } else if (showMenuForth.style.visibility == "visible") {
          // showMenuForth.style.display = 'none';
          showMenuForth.style.visibility = "hidden";

          //reset
          showMenuFirst.style.display = "none";
          showMenuSecond.style.display = "none";
          // showMenuThird.style.display = 'none';

          // dropDown.style.display = 'none';
        } else {
          // showMenuForth.style.display = 'block';
          showMenuForth.style.visibility = "visible";

          //reset
          showMenuFirst.style.display = "none";
          showMenuSecond.style.display = "none";
          // showMenuThird.style.display = 'none';

          // dropDown.style.display = 'none';
        }
      });

      subMenuForth.addEventListener(
        "touchend",
        (ev) => {
          ev.preventDefault();

          if (showMenuForth.style.visibility == "hidden") {
            // showMenuForth.style.display = 'block';
            showMenuForth.style.visibility = "visible";

            //reset
            showMenuFirst.style.display = "none";
            showMenuSecond.style.display = "none";
            // showMenuThird.style.display = 'none';

            // dropDown.style.display = 'none';
          } else if (showMenuForth.style.visibility == "visible") {
            // showMenuForth.style.display = 'none';
            showMenuForth.style.visibility = "hidden";

            //reset
            showMenuFirst.style.display = "none";
            showMenuSecond.style.display = "none";
            // showMenuThird.style.display = 'none';

            // dropDown.style.display = 'none';
          } else {
            // showMenuForth.style.display = 'block';
            showMenuForth.style.visibility = "visible";

            //reset
            showMenuFirst.style.display = "none";
            showMenuSecond.style.display = "none";
            // showMenuThird.style.display = 'none';

            // dropDown.style.display = 'none';
          }
        },
        { passive: false }
      );
    },
    openMenu() {
      const display = document.getElementById("mobileDropDown");

      const open = document.getElementById("menuBtn");

      document.addEventListener(
        "touchstart",
        (e) => {
          e.preventDefault();
          // e.stopPropagation();

          // if(display.style.display == 'block') {
          //     e.stopPropagation();
          // }

          this.moveEvent = true;
        },
        { passive: false }
      );

      open.addEventListener(
        "touchstart",
        (e) => {
          e.preventDefault();
          // e.stopPropagation();

          if (display.style.display == "none") {
            display.style.display = "block";

            document.body.style.overflow = "hidden";
          } else {
            display.style.display = "block";

            document.body.style.overflow = "hidden";
          }

          this.openCheckMenu = true;

          this.$emit("menuOpenCheck", this.openCheckMenu);

          this.startEvent = true;
        },
        { passive: false }
      );

      document.addEventListener(
        "touchmove",
        (e) => {
          e.preventDefault();
          // e.stopPropagation();

          if (display.style.display == "block") {
            this.openCheckMenu = true;

            this.$emit("menuOpenCheck", this.openCheckMenu);

            e.stopPropagation();
          }

          if (!this.startEvent) {
            return;
          }
          this.moveEvent = true;
        },
        { passive: false }
      );

      open.addEventListener("click", () => {
        if (display.style.display == "none") {
          display.style.display = "block";
        } else {
          display.style.display = "block";
        }

        this.openCheckMenu = true;

        this.$emit("menuOpenCheck", this.openCheckMenu);
      });

      open.addEventListener("touchend", (ev) => {
        ev.preventDefault();
      });
    },
    closeMenu() {
      const display = document.getElementById("mobileDropDown");

      const close = document.getElementById("closeBtn");

      close.addEventListener("click", () => {
        if (display.style.display == "block") {
          display.style.display = "none";

          document.body.style.overflow = "auto";
        } else {
          display.style.display = "none";

          document.body.style.overflow = "auto";
        }

        this.openCheckMenu = false;

        this.$emit("menuOpenCheck", this.openCheckMenu);
      });

      close.addEventListener("touchend", (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        if (display.style.display == "block") {
          display.style.display = "none";

          document.body.style.overflow = "auto";
        } else {
          display.style.display = "none";

          document.body.style.overflow = "auto";
        }

        this.openCheckMenu = false;

        this.$emit("menuOpenCheck", this.openCheckMenu);
      });
    },
    loginTouch() {
      const display = document.getElementById("mobileDropDown");

      const login = document.getElementById("loginBtn");
      const memberCheck = document.getElementById("memberBtn");

      console.log("touchLogin: ", this.$store.state.isLogin);

      document.addEventListener(
        "touchstart",
        (e) => {
          e.preventDefault();

          // e.stopPropagation();

          this.startEvent = true;
        },
        { passive: false }
      );

      document.addEventListener(
        "touchmove",
        (e) => {
          e.preventDefault();
          // e.stopPropagation()

          if (!this.startEvent) {
            return;
          }
          this.moveEvent = true;
        },
        { passive: false }
      );

      this.checkLogin();

      if (this.$store.state.isLogin == false) {
        login.addEventListener(
          "touchend",
          (ev) => {
            ev.preventDefault();

            this.$router.push({ name: "로그인" });

            display.style.display = "none";
          },
          false
        );

        login.addEventListener("click", () => {
          display.style.display = "none";
        });

        memberCheck.addEventListener(
          "touchend",
          (ev) => {
            ev.preventDefault();

            this.$router.push({ name: "회원선택" });

            display.style.display = "none";
          },
          false
        );

        memberCheck.addEventListener("click", () => {
          display.style.display = "none";
        });
      }
    },
    myPageTouch() {
      const myPageBtn = document.getElementById("myPageBtn");
      const display = document.getElementById("mobileDropDown");

      console.log("myPageLogin: ", this.$store.state.isLogin);

      document.addEventListener(
        "touchstart",
        (e) => {
          e.preventDefault();

          // e.stopPropagation();

          this.startEvent = true;
        },
        { passive: false }
      );

      document.addEventListener(
        "touchmove",
        (e) => {
          e.preventDefault();
          // e.stopPropagation()

          if (!this.startEvent) {
            return;
          }
          this.moveEvent = true;
        },
        { passive: false }
      );

      this.checkLogin();

      if (this.$store.state.isLogin == true) {
        myPageBtn.addEventListener(
          "touchend",
          (ev) => {
            ev.preventDefault();

            if (this.$store.state.isLogin == true) {
              this.$router.push({ name: "차량 등록 관리", query: { select: "total" } });
            }

            display.style.display = "none";
          },
          false
        );
      }
    },
    routerPage() {
      const showMenuFirst = document.getElementById("firstSubMenu");
      const showMenuSecond = document.getElementById("secondSubMenu");
      // const showMenuThird = document.getElementById("thirdSubMenu");
      const showMenuForth = document.getElementById("fourSubMenu");

      const display = document.getElementById("mobileDropDown");

      const home = document.getElementById("mainImg");

      const parkInfoLink = document.getElementById("parkInfoLink");
      const coinInfo = document.getElementById("coinInfo");
      const discountInfo = document.getElementById("discountInfo");

      const upParkInfo = document.getElementById("upParkInfo");
      const outParkInfo = document.getElementById("outParkInfo");
      // const schoolParkInfo = document.getElementById("schoolParkInfo");

      // const guidance = document.getElementById("guidance");
      // const timeStampLink = document.getElementById("timeStampLink");
      const notice = document.getElementById("notice");
      const frequently = document.getElementById("frequently");
      const questions = document.getElementById("questions");

      // const coinInfo = document.getElementById("secondSubFirst");
      const seasonInfo = document.getElementById("secondSubThird");
      const parkingInformation = document.getElementById("parkingInformation");

      /* 초기화 */
      document.addEventListener(
        "touchstart",
        (e) => {
          e.preventDefault();

          this.startEvent = true;
        },
        { passive: false }
      );

      document.addEventListener(
        "touchmove",
        (e) => {
          e.preventDefault();

          if (!this.startEvent) {
            return;
          }

          this.moveEvent = true;
        },
        { passive: false }
      );

      /* 초기화 끝 */

      //메인 홈으로
      home.addEventListener(
        "touchend",
        (ev) => {
          ev.preventDefault();

          this.$router.push({ name: "홈" });

          display.style.display = "none";
          showMenuFirst.style.display = "none";
          showMenuSecond.style.display = "none";
          // showMenuThird.style.display = 'none';
          // showMenuForth.style.display = 'none';
          showMenuForth.style.visibility = "hidden";

          this.openCheckMenu = false;
          this.$emit("menuOpenCheck", this.openCheckMenu);
        },
        false
      );

      /* 첫번째 메뉴 router */
      parkInfoLink.addEventListener(
        "touchend",
        (ev) => {
          ev.preventDefault();

          this.$router.push({ name: "주차장 소개" });

          display.style.display = "none";

          this.openCheckMenu = false;
          this.$emit("menuOpenCheck", this.openCheckMenu);
        },
        false
      );

      parkInfoLink.addEventListener("click", () => {
        display.style.display = "none";

        this.openCheckMenu = false;
        this.$emit("menuOpenCheck", this.openCheckMenu);
      });

      // guidance.addEventListener('touchend', (ev) => {
      //     ev.preventDefault();

      //     this.$router.push({name: '담당부서 안내'});

      //     display.style.display = 'none';

      // }, false)

      // guidance.addEventListener('click', () => {

      //     display.style.display = 'none';

      // })

      /* 두번째 메뉴 router */
      coinInfo.addEventListener(
        "touchend",
        (ev) => {
          ev.preventDefault();

          this.$router.push({ name: "요금안내" });

          display.style.display = "none";

          this.openCheckMenu = false;
          this.$emit("menuOpenCheck", this.openCheckMenu);
        },
        false
      );

      coinInfo.addEventListener("click", () => {
        display.style.display = "none";

        this.openCheckMenu = false;
        this.$emit("menuOpenCheck", this.openCheckMenu);
      });

      discountInfo.addEventListener(
        "touchend",
        (ev) => {
          ev.preventDefault();

          this.$router.push({ name: "할인안내" });

          display.style.display = "none";

          this.openCheckMenu = false;
          this.$emit("menuOpenCheck", this.openCheckMenu);
        },
        false
      );

      discountInfo.addEventListener("click", () => {
        display.style.display = "none";

        this.openCheckMenu = false;
        this.$emit("menuOpenCheck", this.openCheckMenu);
      });

      parkingInformation.addEventListener(
        "touchend",
        (ev) => {
          ev.preventDefault();

          this.$router.push({ name: "안내사항" });

          display.style.display = "none";

          this.openCheckMenu = false;
          this.$emit("menuOpenCheck", this.openCheckMenu);
        },
        false
      );

      parkingInformation.addEventListener("click", () => {
        display.style.display = "none";

        this.openCheckMenu = false;
        this.$emit("menuOpenCheck", this.openCheckMenu);
      });

      seasonInfo.addEventListener(
        "touchend",
        (ev) => {
          ev.preventDefault();

          this.$router.push({ name: "확인" });

          display.style.display = "none";

          this.openCheckMenu = false;
          this.$emit("menuOpenCheck", this.openCheckMenu);
        },
        false
      );

      seasonInfo.addEventListener("click", () => {
        display.style.display = "none";

        this.openCheckMenu = false;
        this.$emit("menuOpenCheck", this.openCheckMenu);
      });

      /* 두번째 dropDown 메뉴 */
      upParkInfo.addEventListener("touchend", (ev) => {
        ev.preventDefault();

        this.$router.push({ name: "노상주차장 현황" });

        display.style.display = "none";

        this.openCheckMenu = false;
        this.$emit("menuOpenCheck", this.openCheckMenu);
      });

      upParkInfo.addEventListener("click", () => {
        display.style.display = "none";

        this.openCheckMenu = false;
        this.$emit("menuOpenCheck", this.openCheckMenu);
      });

      outParkInfo.addEventListener("touchend", (ev) => {
        ev.preventDefault();

        this.$router.push({ name: "노외주차장 현황" });

        display.style.display = "none";

        this.openCheckMenu = false;
        this.$emit("menuOpenCheck", this.openCheckMenu);
      });

      outParkInfo.addEventListener("click", () => {
        display.style.display = "none";

        this.openCheckMenu = false;
        this.$emit("menuOpenCheck", this.openCheckMenu);
      });

      // schoolParkInfo.addEventListener('touchend', (ev) => {
      //     ev.preventDefault();

      //     if(!this.checkMobile || this.mobileTouch){

      //         this.$router.push({name: '학교주차장 현황'});
      //     }

      //     display.style.display = 'none';

      // })

      // schoolParkInfo.addEventListener('click', () => {

      //     display.style.display = 'none';

      // })

      /* 세번째 메뉴 router */
      // timeStampLink.addEventListener('touchend', (ev) => {
      //     ev.preventDefault();

      //     if(!this.checkMobile || this.mobileTouch){
      //         this.$router.push({name: '실시간정보'});
      //     }

      //     display.style.display = 'none';

      // }, false)

      // timeStampLink.addEventListener('click', () => {

      //     display.style.display = 'none';

      // })

      /* 네번째 메뉴 router */
      notice.addEventListener(
        "touchend",
        (ev) => {
          ev.preventDefault();

          this.$router.push({ name: "공지 사항" });

          display.style.display = "none";

          this.openCheckMenu = false;
          this.$emit("menuOpenCheck", this.openCheckMenu);
        },
        false
      );

      notice.addEventListener("click", () => {
        display.style.display = "none";

        this.openCheckMenu = false;
        this.$emit("menuOpenCheck", this.openCheckMenu);
      });

      frequently.addEventListener(
        "touchend",
        (ev) => {
          ev.preventDefault();

          this.$router.push({ name: "자주하는 질문" });

          display.style.display = "none";

          this.openCheckMenu = false;
          this.$emit("menuOpenCheck", this.openCheckMenu);
        },
        false
      );

      frequently.addEventListener("click", () => {
        display.style.display = "none";

        this.openCheckMenu = false;
        this.$emit("menuOpenCheck", this.openCheckMenu);
      });

      questions.addEventListener(
        "touchend",
        (ev) => {
          ev.preventDefault();

          this.$router.push({ name: "차량변경/환불요청" });

          display.style.display = "none";

          this.openCheckMenu = false;
          this.$emit("menuOpenCheck", this.openCheckMenu);
        },
        false
      );

      questions.addEventListener("click", () => {
        display.style.display = "none";
      });
    },
    doLogout() {
      console.log("do logout");

      document.addEventListener(
        "touchstart",
        (e) => {
          e.preventDefault();

          // e.stopPropagation();

          this.startEvent = true;
        },
        { passive: false }
      );

      document.addEventListener(
        "touchmove",
        (e) => {
          e.preventDefault();
          // e.stopPropagation()

          if (!this.startEvent) {
            return;
          }
          this.moveEvent = true;
        },
        { passive: false }
      );

      const logoutBtn = document.getElementById("logoutBtn");

      logoutBtn.addEventListener("click", () => {
        build
          .get("/mer/api/member/logout")
          .then((res) => {
            console.log(res);
            this.$store.state.isLogin = false;
            this.$store.state.isAdmin = false;
            this.$store.state.isBusiness = false;

            this.$cookies.remove("JSESSIONID");

            this.$router.push({ name: "홈" });
            this.$router.go(0);
          })
          .catch((err) => {
            console.log(err);
          });
      });

      logoutBtn.addEventListener("touchend", (ev) => {
        ev.preventDefault();

        build
          .get("/mer/api/member/logout")
          .then((res) => {
            console.log(res);
            this.$store.state.isLogin = false;
            this.$store.state.isAdmin = false;
            this.$store.state.isBusiness = false;

            this.$router.push({ name: "홈" });
            this.$router.go(0);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    isMobile() {
      var user = navigator.userAgent;

      if (
        user.indexOf("iPhone") > -1 ||
        user.indexOf("Android") > -1 ||
        user.indexOf("iPad") > -1 ||
        user.indexOf("iPod") > -1
      ) {
        this.checkMobile = true;
      }
    },

    menuOutAreaTouchCloseMenuInfo() {
      const display = document.getElementById("mobileDropDown");

      if (display.style.display == "block") {
        display.style.display = "none";

        document.body.style.overflow = "auto";
      } else {
        display.style.display = "none";

        document.body.style.overflow = "auto";
      }
    },
  },
  mounted() {
    this.openMenu();
    this.closeMenu();
    this.openDropDown();
    this.routerPage();
    this.loginTouch();

    this.isMobile();

    this.$emit("menuOpenCheck", this.openCheckMenu);

    window.addEventListener("touchmove", () => {
      this.mobileTouch = false;
    });

    window.addEventListener("touchstart", () => {
      this.mobileTouch = true;
    });

    window.addEventListener("touchcancel", () => {
      this.mobileTouch = true;
    });

    window.addEventListener("touchend", () => {
      this.mobileTouch = true;
    });
  },
  unmounted() {
    window.removeEventListener("touchmove", () => {});
    window.removeEventListener("touchstart", () => {});
    window.removeEventListener("touchcancel", () => {});
    window.removeEventListener("touchend", () => {});
  },
  updated() {
    this.checkLogin();

    if (this.$store.state.isLogin == true) {
      this.myPageTouch();

      this.doLogout();
    } else if (this.$store.state.isLogin == false) {
      this.loginTouch();
    }
  },
};
</script>

<style scoped>
@import "@/assets/css/reset.css";

* {
  touch-action: manipulation;
}

/* line */
.line1 {
  margin: 0;
  margin-top: 3%;
  margin-bottom: 3%;
  width: 90%;
  float: right;
  margin-right: 3vw;
  border-top: 1.5px dashed #c3c3c3;
  background-color: transparent;
}

.line2 {
  margin: 0;
  margin-top: 1%;
  margin-bottom: 2%;
  margin-right: 3vw;
  width: 63%;
  float: right;
  border-top: 1px dashed #c3c3c3;
  background-color: transparent;
}

.line3 {
  margin: 0;
  margin-right: 3vw;
  width: 52%;
  float: right;
  border-top: 1px dashed #c3c3c3;
  background-color: transparent;
}

.line4 {
  margin: 0;
  margin-top: 1%;
  margin-bottom: 0;
  margin-right: 3vw;
  width: 63%;
  float: right;
  border-top: 1px dashed #c3c3c3;
  background-color: transparent;
}
/* menu display animation */
.slideShow-enter-active {
  transition: all 0.3s ease-out;
}

.slideShow-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slideShow-enter-from,
.slideShow-leave-to {
  transform: translateX(20px);
}

/* width size 1000px */
.mobileMenu {
  margin: auto;
  text-align: center;
  width: 100vw !important;
}

.mobileMain {
  display: inline-block;
  z-index: 5;
  padding-top: 2%;
  padding-bottom: 2%;
  width: 95vw !important;
  height: auto;
  background-color: #ffffff !important;
}

.mainImg {
  display: inline-block;
  padding-top: 1.5%;
}

.menuBtn {
  width: 35px;
  float: left;
  padding: 3% 2% 4% 5%;
  font: normal normal 35px/26px Noto Sans KR-BOLD;
  border-color: transparent;
  color: #1f7a37;
}

.menuBtn:hover {
  border-color: transparent;
}

/* subMenu */
.mobileDropDown {
  display: none;
  top: -10%;
  position: absolute;
  z-index: 3000;
  background-color: #ffffff;
  width: 70%;
  height: 100vh;

  box-shadow: 0px 3px 6px #00000029;
}

.logoTitle {
  background: #008fd2 0% 0% no-repeat padding-box;
  padding-bottom: 2%;
}

.mainTitle {
  width: auto;
  padding-top: 2%;
}

.closeWrapper {
  display: flex;
  align-items: center;
}

/* 닫기 버튼 */
.mobile-close-button {
  margin: 0;
  font: normal normal normal 15px/21px Noto Sans KR;
  letter-spacing: -0.3px;
  color: #ffffff;
  padding: 1%;
  margin-left: 5%;
}

.logoTitle >>> .mainFullTitle {
  height: 60px !important;
}

.mobileDropDown >>> .mainFullTitle {
  white-space: pre !important;
  background: #008fd2 0% 0% no-repeat padding-box;
  height: 80px;
}

/* img {
  height: auto !important;
  width: auto !important;
} */

.logoTitle >>> .titleImg {
  width: 80%;
  margin: 0;
  margin-bottom: 2%;
  margin-top: 2%;
}

.logoTitle >>> .closeBtn {
  margin: 0;
  float: right;
  font: normal normal normal 15px/21px Noto Sans KR;
  letter-spacing: -0.3px;
  color: #ffffff;
  margin-right: 7%;
  margin-top: 5%;
  border-color: transparent;
  background-color: transparent;
  padding: 1%;
}

.userName {
  font: normal normal normal 12px/17px Noto Sans KR;
  letter-spacing: -0.3px;
  color: #ffffff;
}

ul >>> .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 45px;
  padding-top: 4.8%;
  padding-bottom: 1%;
  text-align: left;
  font: normal normal normal 15px/21px Noto Sans KR;
  letter-spacing: -0.38px;
  color: #191c1d;
  margin-left: 10%;
  /* background: #D4F0FF 0% 0% no-repeat padding-box; */
  /* border-bottom: 1px solid #FFFFFF; */
}

/* .clickTitleForth {
        height: 10vh;
        margin-bottom: 5vh;
    } */

/* #clickTitleSecond >>> .mobileArrow{
        width: auto !important;
    } */

.subMenu {
  height: 30px;
  margin: 1.5vh 0 0 0;
  /* margin-left: 30vw; */
  text-align: left;
  font: normal normal normal 15px/21px Noto Sans KR;
  letter-spacing: -0.38px;
  color: #191c1d;
  display: table;

  list-style: none;
}

.checkSubMenu {
  height: 25px;
  margin: 1.5vh 0 0 0;
  /* margin-left: 30vw; */
  text-align: left;
  font: normal normal normal 15px/21px Noto Sans KR;
  letter-spacing: -0.38px;
  color: #191c1d;

  list-style: none;
}

.checkSubMenuInfo {
  height: 25px;
  margin: 1.5vh 0 0 0;
  /* margin-left: 30vw; */
  text-align: left;
  font: normal normal normal 15px/21px Noto Sans KR;
  letter-spacing: -0.38px;
  color: #191c1d;

  list-style: none;
}

.checkSubMenuInfo::marker {
  content: none;
}

.checkSubMenu::marker {
  content: none;
}
.subMenu::marker {
  content: none;
}

.marker {
  font-size: 11px;
  text-align: center;
  color: #008fd2;
  padding-left: 2%;
  float: left;
  /* margin-top: 2%; */
  margin-left: 30%;
  text-size-adjust: 170%;
}

.checkMarker {
  font-size: 11px;
  text-align: center;
  color: #008fd2;
  padding-left: 2%;
  float: left;
  /* margin-top: 2%; */
  margin-left: 30%;
  text-size-adjust: 170%;
}

.subMarker {
  margin-left: 30vw !important;
  font-size: 11px;
  text-align: center;
  color: #008fd2;
  padding-left: 1vw;
  float: left;
  margin-top: 1vh;
  text-size-adjust: 150%;
}

/* 하위 메뉴 안보이는 부분 */
.firstSubMenu {
  display: none;
  background: #ffffff 0% 0% no-repeat padding-box;
}

.thirdSubMenu {
  display: none;
  background: #ffffff 0% 0% no-repeat padding-box;
}

.fourSubMenu {
  /* display: none; */
  visibility: hidden;
  background: #ffffff 0% 0% no-repeat padding-box;
}

.secondSubMenu {
  display: none;
  background: #ffffff 0% 0% no-repeat padding-box;
}

.subMenuRouterLink {
  display: flex;
  align-items: center;
  width: 100%;
}

/* 두번째 메뉴 드롭다운 */
.secondDropMenu {
  /* display: none; */
  background: #ffffff 0% 0% no-repeat padding-box;
}

.memberButton {
  display: flex;
  align-items: center;
  margin-top: 7%;
  margin-left: 5%;
  /* margin-right: 44%; */
}

.dropSubMenu {
  height: auto;
  color: #191c1d;
  font: normal normal 300 13px/29px Noto Sans KR;
  background: #ffffff 0% 0% no-repeat padding-box;
  /* margin-right: 2vw; */

  list-style: none;
}

.dropSubMenu::marker {
  content: none;
}

.loginMobile {
  background: #008fd2 0% 0% no-repeat padding-box;
}

.loginBtn {
  font: normal normal normal 15px/21px Noto Sans KR;
  letter-spacing: -0.3px;
  color: #ffffff;
}

.memberBtn {
  font: normal normal normal 15px/21px Noto Sans KR;
  letter-spacing: -0.3px;
  color: #ffffff;
}

.bar {
  font: normal normal normal 12px/17px Noto Sans KR;
  letter-spacing: -0.3px;
  color: #ffffff;
  margin: 0 5% 0 5%;
}

.myBar {
  font: normal normal normal 12px/17px Noto Sans KR;
  letter-spacing: -0.3px;
  color: #ffffff;
  margin: 0 5% 0 5%;
}

/* Arrow */
.mobileArrow {
  width: 50px !important;
  height: 30px !important;
  padding-top: 3%;
  font-size: 45px;
  font-weight: 300;
  color: #008fd2 !important;
  /* margin-left: 52% !important; */
  /* margin-left: 39% !important; */
  display: inline-block;
  margin-right: 5%;
  /* background: transparent url('img/ic-chevron-right.png') 0% 0% no-repeat padding-box; */
}

.mobileFirstArrow {
  width: 12px !important;
  height: 30px !important;
  /* padding-top: 3%; */
  font-size: 45px;
  font-weight: 300;
  color: #008fd2 !important;
  /* margin-left: 39.7% !important; */
  display: inline-block;
  margin-right: 17%;
}

.adminBtn {
  width: 110px;
  display: inline-block;
}

.admin {
  margin: 0;
  display: inline-block;
  text-decoration: none;
  padding: 12px 0 0 0;
  color: #707070;
  font: normal normal 300 15px/29px Noto Sans KR;
}

@media all and (max-width: 468px) {
  .mainTitle {
    padding-top: 5%;
  }
  .mainImg {
    padding-top: 0;
  }
  .menuBtn {
    margin: 0;
    padding-right: 10px;
  }

  .logoTitle >>> .closeBtn {
    margin-top: 0%;
  }

  /* Arrow */
  .mobileArrow {
    width: 50px !important;
    height: 50px;
    font-size: 45px;
    font-weight: 500;
    margin-left: 18%;
    padding-top: 0.5vh;
  }
  .marker {
    font-size: 14px;
    text-size-adjust: 130%;
  }

  .checkMarker {
    font-size: 14px;
    text-size-adjust: 130%;
  }
  .line4 {
    margin-top: 0;
  }
}

@media all and (max-width: 360px) {
  .mainTitle {
    padding-top: 5%;
  }

  .mainImg {
    /* float: left; */
    margin: 0;
    float: right;
    width: 74vw !important;
  }

  .menu {
    margin: 0;
    padding-right: 10px;
  }

  /* .memberButton {
            margin-top: 0;
        } */

  /* .titleImg {
    float: right;
    width: 60vw !important;
  } */
  /* width: 74% !important; */
  /* float: left; */
  /* margin-left: 5% !important; */

  .logoTitle {
    padding-top: 4%;
  }

  .logoTitle >>> .closeBtn {
    padding: 0;
    padding-right: 4%;
    padding-top: 3%;
    /* font: normal normal normal 10px/17px Noto Sans KR; */
  }

  /* Arrow */
  .mobileArrow {
    width: 45px;
    height: 45px;
    font-size: 30px;
    font-weight: 500;
    margin-left: 20% !important;
  }

  .mobileFirstArrow {
    font-size: 30px;
    font-weight: 500;
    margin-left: 20% !important;
  }
  .subMenu {
    font: normal normal normal 12px/17px Noto Sans KR;
  }

  .loginBtn {
    font: normal normal normal 15px/21px Noto Sans KR;
  }

  .memberBtn {
    font: normal normal normal 15px/21px Noto Sans KR;
    /* padding-top: 10px; */
  }
  .checkSubMenuInfo {
    font: normal normal normal 12px/17px Noto Sans KR;
  }
  .checkSubMenu {
    font: normal normal normal 12px/17px Noto Sans KR;
  }
  .dropSubMenu {
    font: normal normal normal 10px/21px Noto Sans KR;
  }
  ul >>> .title {
    font: normal normal normal 12px/18px Noto Sans KR;
  }
}
</style>
